// https://developer.cardconnect.com/hosted-iframe-tokenizer#whitelisted-css-properties
export const IFRAME_CSS_WHITELIST = [
  '-moz-border-radius',
  '-moz-border-radius-bottomleft',
  '-moz-border-radius-bottomright',
  '-moz-border-radius-topleft',
  '-moz-border-radius-topright',
  '-moz-box-shadow',
  '-moz-outline',
  '-moz-outline-color',
  '-moz-outline-style',
  '-moz-outline-width',
  '-o-text-overflow',
  '-webkit-border-bottom-left-radius',
  '-webkit-border-bottom-right-radius',
  '-webkit-border-radius',
  '-webkit-border-radius-bottom-left',
  '-webkit-border-radius-bottom-right',
  '-webkit-border-radius-top-left',
  '-webkit-border-radius-top-right',
  '-webkit-border-top-left-radius',
  '-webkit-border-top-right-radius',
  '-webkit-box-shadow',
  'azimuth',
  'background',
  'background-attachment',
  'background-color',
  'background-image',
  'background-position',
  'background-repeat',
  'border',
  'border-bottom',
  'border-bottom-color',
  'border-bottom-left-radius',
  'border-bottom-right-radius',
  'border-bottom-style',
  'border-bottom-width',
  'border-collapse',
  'border-color',
  'border-left',
  'border-left-color',
  'border-left-style',
  'border-left-width',
  'border-radius',
  'border-right',
  'border-right-color',
  'border-right-style',
  'border-right-width',
  'border-spacing',
  'border-style',
  'border-top',
  'border-top-color',
  'border-top-left-radius',
  'border-top-right-radius',
  'border-top-style',
  'border-top-width',
  'border-width',
  'box-shadow',
  'caption-side',
  'color',
  'cue',
  'cue-after',
  'cue-before',
  'direction',
  'elevation',
  'empty-cells',
  'font',
  'font-family',
  'font-size',
  'font-stretch',
  'font-style',
  'font-variant',
  'font-weight',
  'height',
  'letter-spacing',
  'line-height',
  'list-style',
  'list-style-image',
  'list-style-position',
  'list-style-type',
  'margin',
  'margin-bottom',
  'margin-left',
  'margin-right',
  'margin-top',
  'max-height',
  'max-width',
  'min-height',
  'min-width',
  'outline',
  'outline-color',
  'outline-style',
  'outline-width',
  'padding',
  'padding-bottom',
  'padding-left',
  'padding-right',
  'padding-top',
  'pause',
  'pause-after',
  'pause-before',
  'pitch',
  'pitch-range',
  'quotes',
  'richness',
  'speak',
  'speak-header',
  'speak-numeral',
  'speak-punctuation',
  'speech-rate',
  'stress',
  'table-layout',
  'text-align',
  'text-decoration',
  'text-indent',
  'text-overflow',
  'text-shadow',
  'text-transform',
  'text-wrap',
  'unicode-bidi',
  'vertical-align',
  'voice-family',
  'volume',
  'white-space',
  'width',
  'word-spacing',
  'word-wrap',
  'box-sizing',
];
